
      import API from "!../../../../../../nix/store/crly7ca7psni9wx782rlvi63sx6dk99v-modusense-spa-yarn-deps-1.0/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../../../nix/store/crly7ca7psni9wx782rlvi63sx6dk99v-modusense-spa-yarn-deps-1.0/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../../../../nix/store/crly7ca7psni9wx782rlvi63sx6dk99v-modusense-spa-yarn-deps-1.0/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../../../../nix/store/crly7ca7psni9wx782rlvi63sx6dk99v-modusense-spa-yarn-deps-1.0/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../../../../nix/store/crly7ca7psni9wx782rlvi63sx6dk99v-modusense-spa-yarn-deps-1.0/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../../../../nix/store/crly7ca7psni9wx782rlvi63sx6dk99v-modusense-spa-yarn-deps-1.0/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../../../../nix/store/crly7ca7psni9wx782rlvi63sx6dk99v-modusense-spa-yarn-deps-1.0/node_modules/css-loader/dist/cjs.js!../../../../../../nix/store/crly7ca7psni9wx782rlvi63sx6dk99v-modusense-spa-yarn-deps-1.0/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./D3DevicePowerPerformanceStyle.scss";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../../../nix/store/crly7ca7psni9wx782rlvi63sx6dk99v-modusense-spa-yarn-deps-1.0/node_modules/css-loader/dist/cjs.js!../../../../../../nix/store/crly7ca7psni9wx782rlvi63sx6dk99v-modusense-spa-yarn-deps-1.0/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./D3DevicePowerPerformanceStyle.scss";
       export default content && content.locals ? content.locals : undefined;
